"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setThreeQuaternion = void 0;
function setThreeQuaternion(target, q) {
    target.set(q.x, q.y, q.z, q.w);
}
exports.setThreeQuaternion = setThreeQuaternion;
